<template>
  <section>
    <b-card-code
      title="Summary"
      no-body
    >
      <b-card>
        <b-row>
          <b-col
            xl="12"
            sm="12"
          >
            <b-row>
              <b-col
                v-for="item in data"
                :key="item.icon"
                xl="3"
                sm="6"
                :class="item.customClass"
              >
                <b-media no-body>
                  <b-media-aside

                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      :variant="item.color"
                    >
                      <b-img :src="item.icons" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body
                    class="my-auto"
                    style="text-align: center;"
                  >
                    <h4 class="font-weight-bolder mb-0">
                      {{ item.subtitle }}
                    </h4>
                    <b-card-text class="xmb-0">
                      {{ item.title }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-card-code>
    <b-card-code
      title="Filter"
      no-body
    >
      <b-card>
        <b-row
          xl="12"
          sm="12"
        >
          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-Province"
              v-model="select_6"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="ProvinceOptions"
              :reduce="(ProvinceOptions) => ProvinceOptions.value"
              label="title"
              placeholder="--Select Province --"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-Regency"
              v-model="select_7"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="RegencyOptions"
              :reduce="(RegencyOptions) => RegencyOptions.value"
              label="title"
              placeholder="--Select Regency --"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
          >
            <v-select
              v-model="select_site"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="SiteOptions"
              :reduce="(SiteOptions) => SiteOptions.value"
              label="title"
              placeholder="Site"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="mb-md-0 mb-2"
          >
&nbsp;
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mb-md-0 mb-2"
          >
            <v-select
              v-model="select_device_type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="DeviceTypeOptions"
              :reduce="(DeviceTypeOptions) => DeviceTypeOptions.value"
              label="title"
              placeholder="Device Type"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mb-md-0 mb-2"
          >
            <v-select
              v-model="select_status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="StatusOptions"
              :reduce="(StatusOptions) => StatusOptions.value"
              label="title"
              placeholder="Status"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="mb-md-0 mb-2"
          >
&nbsp;
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              class="sidebar-center"
              variant="outline-primary"
              @click="filterz()"
            >
              <feather-icon icon="SearchIcon" /> Filter
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-card-code>
    <b-card-code
      title="Data"
      no-body
    >
      <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-card>
          <div class="d-flex justify-content-between flex-wrap">
            <!-- sorting  -->
            <b-row>
              <b-col cols="0">
                <div>
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    class="ml-1 mb-1"
                    variant="outline-primary"
                    @click="exportExcel"
                  >
                    <feather-icon icon="DownloadIcon" /> Export
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <!-- filter -->
            <b-form-group
              label="Filter"
              label-cols-sm="2"
              label-align-sm="left"
              label-size="sm"
              label-for="filterInput"
              class="mr-1"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <b-table
            striped
            hover
            responsive
            sticky-header
            class="position-relative"
            :items="$store.state.temperature.deviceList.items"
            :fields="$store.state.temperature.deviceList.fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            style="max-height: 600px; overflow-y: auto;"
            @filtered="onFiltered"
          >
            <template #cell(is_offline_alarm)="row">
              <b-avatar
                v-if="row.item.is_offline_alarm === false && projectUndp !== 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_offline_alarm === true && projectUndp !== 6"
                size="sm"
                variant="danger"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_offline_alarm === false && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.status === 'ER' && projectUndp === 6"
                size="sm"
                style="color: black;"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_offline_alarm === true && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="danger"
                text=" "
              />
            </template>
            <template #cell(is_over_limit_max)="row">
              <b-avatar
                v-if="row.item.is_over_limit_max === false && projectUndp !== 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_over_limit_max === true && projectUndp !== 6"
                size="sm"
                variant="danger"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_over_limit_max === false && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.status === 'ER' && projectUndp === 6"
                size="sm"
                style="color: black;"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_over_limit_max === true && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="danger"
                text=" "
              />
            </template>
            <template #cell(is_over_limit_min)="row">
              <b-avatar
                v-if="row.item.is_over_limit_min === false && projectUndp !== 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_over_limit_min === true && projectUndp !== 6"
                size="sm"
                variant="danger"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_over_limit_min === false && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.status === 'ER' && projectUndp === 6"
                size="sm"
                style="color: black;"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_over_limit_min === true && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="danger"
                text=" "
              />
            </template>
            <template #cell(is_power_disconnect)="row">
              <b-avatar
                v-if="row.item.is_power_disconnect === false && projectUndp !== 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_power_disconnect === true && projectUndp !== 6"
                size="sm"
                variant="danger"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_power_disconnect === false && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.status === 'ER' && projectUndp === 6"
                size="sm"
                style="color: black;"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_power_disconnect === true && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="danger"
                text=" "
              />
            </template>
            <template #cell(is_power_low)="row">
              <b-avatar
                v-if="row.item.is_power_low === false && projectUndp !== 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_power_low === true && projectUndp !== 6"
                size="sm"
                variant="danger"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_power_low === false && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.status === 'ER' && projectUndp === 6"
                size="sm"
                style="color: black;"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_power_low === true && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="danger"
                text=" "
              />
            </template>
            <template #cell(is_power_shutdown)="row">
              <b-avatar
                v-if="row.item.is_power_shutdown === false && projectUndp !== 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_power_shutdown === true && projectUndp !== 6"
                size="sm"
                variant="danger"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_power_shutdown === false && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.status === 'ER' && projectUndp === 6"
                size="sm"
                style="color: black;"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_power_shutdown === true && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="danger"
                text=" "
              />
            </template>
            <template #cell(is_probe_fault)="row">
              <b-avatar
                v-if="row.item.is_probe_fault === false && projectUndp !== 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_probe_fault === true && projectUndp !== 6"
                size="sm"
                variant="danger"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_probe_fault === false && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="success"
                text=" "
              />
              <b-avatar
                v-if="row.item.status === 'ER' && projectUndp === 6"
                size="sm"
                style="color: black;"
                text=" "
              />
              <b-avatar
                v-if="row.item.is_probe_fault === true && row.item.status === 'IN' && projectUndp === 6"
                size="sm"
                variant="danger"
                text=" "
              />
            </template>
            <template #cell(last_online_device)="data">
              {{ dateFormat(data.value) }}
            </template>
            <template #cell(last_send_data)="data">
              {{ dateFormat(data.value) }}
            </template>
            <template #cell(created_at)="data">
              {{ dateFormat(data.value) }}
            </template>
            <template #cell(code)="row">
              <b-link
                :to="{ path: '/temperature-device/detail/' + row.item.id }"
              >
                <span>{{ row.item.code }}</span>
              </b-link>
            </template>
            <template #cell(serial_number)="row">
              <b-link
                :to="{ path: '/temperature-device/detail/' + row.item.id }"
              >
                <span>{{ row.item.serial_number }}</span>
              </b-link>
            </template>
            <template #cell(value)="row">
              {{ row.item.value ? Number(row.item.value).toFixed(2) : "0.00" }}{{ row.item.default_unit }}
            </template>
            <template #cell(device_status_connection)="data">
              <b-badge :variant="device_status[1][data.value]">
                {{ device_status[0][data.value] }}
              </b-badge>
            </template>
            <template #cell(status)="data">
              <b-badge :variant="status[1][data.value]">
                {{ status[0][data.value] }}
              </b-badge>
            </template>
            <template #cell(action)="row">
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item>
                    <b-link
                      :to="{
                        path: '/temperature-device/detail/' + row.item.id,
                      }"
                    >
                      <feather-icon
                        icon="AirplayIcon"
                        class="mr-50"
                      />
                      <span>Detail</span>
                    </b-link>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <b-link
                      :to="{
                        path: '/temperature-device/edit/' + row.item.id,
                      }"
                    >
                      <feather-icon
                        icon="Edit2Icon"
                        class="mr-50"
                      />
                      <span>Edit</span>
                    </b-link>
                  </b-dropdown-item>
                  <b-dropdown-item v-if="row.item.device_status === 'ER'">
                    <b-link
                      :to="{
                        path: '/temperature-device/timeline/' + row.item.device_id,
                      }"
                    >
                      <feather-icon
                        icon="ClockIcon"
                        class="mr-50"
                      />
                      <span>Timeline</span>
                    </b-link>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
            </template>
          </b-table>
          <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
            <!-- page length -->
            <b-form-group
              label="Per Page"
              label-cols="6"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
            >
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                inline
                :options="pageOptions"
                @change="filterData"
              />
            </b-form-group>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="$store.state.temperature.deviceList.totalRows"
                :per-page="$store.state.temperature.deviceList.perPage"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
                style="align-content: right"
                @input="filterData"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </b-card-body>
        </b-card>
      </b-overlay>
    </b-card-code>
  </section>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCol,
  BOverlay,
  BCard,
  BRow,
  BTable,
  BImg,
  BBadge,
  BMediaBody,
  BAvatar,
  BCardText,
  BMediaAside,
  BMedia,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BLink,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import XLSX from 'xlsx'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({ name: XLSX.utils.encode_col(i), key: i }))
const _SheetJSFT = ['xlsx', 'xlsb', 'xlsm', 'xls', 'xml', 'csv', 'txt', 'ods', 'fods', 'uos', 'sylk', 'dif', 'dbf', 'prn', 'qpw', '123', 'wb*', 'wq*', 'html', 'htm'].map(x => `.${x}`).join(',')

export default {
  components: {
    BCardCode,
    XLSX,
    vSelect,
    BCol,
    BOverlay,
    BCard,
    BRow,
    BTable,
    BImg,
    BBadge,
    BMediaBody,
    BAvatar,
    BCardText,
    BMediaAside,
    BMedia,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BLink,
    BDropdown,
    BDropdownItem,
    ToastificationContent,
  },
  data() {
    return {
      data: [
        {
          icons: require('@/assets/images/icons/site.png'),
          icon: 'UsersIcon',
          color: 'light-warning',
          title: 0,
          subtitle: 'Total',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/online.png'),
          icon: 'UserIcon',
          color: 'light-info',
          title: 0,
          subtitle: 'Online',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/offline.png'),
          icon: 'DollarSignIcon',
          color: 'light-success',
          subtitle: 'Offline',
          title: 0,
          customClass: 'mb-3 mb-sm-0',
        },
        {
          icons: require('@/assets/images/icons/offline.png'),
          icon: '',
          color: 'light-info',
          title: 0,
          subtitle: 'Error',
          customClass: 'mb-3 mb-xl-0',
        },
      ],
      dir: false,
      show: false,
      currentPage: 1,
      perPage: 10,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      select_6: '',
      select_7: '',
      select_8: '',
      select_9: '',
      select_site: '',
      select_device_type: '',
      select_status: '',
      projectUndp: 0,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      StatusOptions: [
        { title: 'Online', value: 'IN' },
        { title: 'Offline', value: 'ER' },
        { title: 'Error', value: 'FL' },
      ],
      status: [
        {
          FL: 'Error',
          IN: 'Online',
          ER: 'Offline',
        },
        {
          FL: 'light-warning',
          IN: 'light-success',
          ER: 'light-secondary',
        },
      ],
      device_status: [
        {
          ONLINE: 'Online',
          OFFLINE: 'Offline',
        },
        {
          ONLINE: 'light-success',
          OFFLINE: 'light-warning',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      ProvinceOptions: state => state.region.province,
      RegencyOptions: state => state.region.regency,
      DistrictOptions: state => state.region.district,
      SiteOptions: state => state.site.options,
      LocationOptions: state => state.location.options,
      DeviceTypeOptions: state => state.temperature.devicetypeoptions,
      totalRows: state => state.temperature.deviceList.totalRows,
      totalActive: state => state.temperature.deviceList.totalActive,
      totalOffline: state => state.temperature.deviceList.totalOffline,
      totalError: state => state.temperature.deviceList.totalError,
      fields: state => state.temperature.deviceList.fields,
      items: state => state.temperature.deviceList.items,
      pageOptions: state => state.temperature.deviceList.pageOptions,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    totalExpenses() {
      return this.items.reduce((accum, item) =>
        // Assuming expenses is the field you want to total up
        accum + parseFloat(item.expenses),
      0.0)
    },
    dateFormat() {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    },
    mapFilter() {
      return {
        page: this.currentPage,
        limit: this.perPage,
        province_id: this.select_6,
        regency_id: this.select_7,
        district_id: this.select_8,
        site_id: this.select_site,
        device_type_id: this.select_device_type,
        status: this.select_status,
      }
    },
  },
  watch: {
    select_6(obj) {
      this.$store.dispatch('site/setFilterProvince', obj)
      return this.$store.dispatch('region/regency', obj)
    },
    select_7(obj) {
      this.$store.dispatch('site/setFilterRegency', obj)
      return this.$store.dispatch('region/district', obj)
    },
  },
  created() {
    useJwt.getProfile().then(response => {
      this.projectUndp = response.data.data.user_projects[0].project_id
      this.show = true
      this.$store.dispatch('temperature/getDeviceType')
      this.$store.dispatch('region/province')
      this.$store.dispatch('site/setFilterRegency', '')
      this.$store.dispatch('location/getAll')
      this.setData()
    })
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // With server-side pagination, this method is only needed for local filtering
      // If we're using the search box to filter items that are already loaded
      if (this.filter) {
        // Update the display counts based on filtered items
        this.data[0].title = filteredItems.length
        this.data[1].title = filteredItems.filter(f => f.device_status === 'IN').length
        this.data[2].title = filteredItems.filter(f => f.device_status === 'ER').length
        this.data[3].title = filteredItems.filter(f => f.device_status === 'FL').length
      }
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    rowOnDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete everything.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$store.dispatch('device/remove', id).then(
              response => {
                if (response.status === 200) {
                  this.$store.dispatch('device/getAll')
                  this.notification(
                    'Success',
                    'CheckIcon',
                    'success',
                    'You have successfully',
                  )
                } else {
                  this.notification(
                    'Failed',
                    'CloseIcon',
                    'danger',
                    'You have unsuccessful',
                  )
                }
              },
              error => {
                this.notification(
                  'Failed',
                  'CloseIcon',
                  'danger',
                  'You have unsuccessful',
                )
              },
            )
          }
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    filterz() {
      this.show = true
      this.currentPage = 1
      this.$store.dispatch('temperature/getDeviceList', this.mapFilter).then(() => {
        this.data[0].title = this.$store.state.temperature.deviceList.totalRows
        this.data[1].title = this.$store.state.temperature.deviceList.totalActive
        this.data[2].title = this.$store.state.temperature.deviceList.totalOffline
        this.data[3].title = this.$store.state.temperature.deviceList.totalError
        this.show = false
      })
    },
    setData() {
      useJwt.getProfile().then(response => {
        this.projectUndp = response.data.data.user_projects[0].project_id
      })
      this.$store.dispatch('temperature/getDeviceList', this.mapFilter).then(() => {
        this.data[0].title = this.$store.state.temperature.deviceList.totalRows
        this.data[1].title = this.$store.state.temperature.deviceList.totalActive
        this.data[2].title = this.$store.state.temperature.deviceList.totalOffline
        this.data[3].title = this.$store.state.temperature.deviceList.totalError
        this.show = false
      })
    },
    filterData() {
      this.show = true
      this.$store.dispatch('temperature/getDeviceList', this.mapFilter).then(() => {
        // Update summary data
        this.data[0].title = this.$store.state.temperature.deviceList.totalRows
        this.data[1].title = this.$store.state.temperature.deviceList.totalActive
        this.data[2].title = this.$store.state.temperature.deviceList.totalOffline
        this.data[3].title = this.$store.state.temperature.deviceList.totalError
        this.show = false
      })
    },
    exportExcel(evt) {
      const jsons = []
      for (let x = 0; x < this.items.length; x++) {
        jsons[x] = {
          No: this.items[x].no,
          'Site Name': this.items[x].site_name,
          'Device Code': this.items[x].device_code,
          'Device SN': this.items[x].device_serial_number,
          MSISDN: this.items[x].device_msisdn,
          Value: `${this.items[x].device_value} ${this.items[x].device_default_unit}`,
          Power: this.items[x].device_value_power,
          Signal_Strenght: this.items[x].device_signal_strength,
          Type: this.items[x].device_type_name,
          Note: this.items[x].device_note,
          Status: this.status[0][this.items[x].device_status],
          Last_Online: this.items[x].last_online_device,
          Last_Sent: this.items[x].device_last_send_data,
          Offline_Alarm: this.items[x].device_is_offline_alarm,
          Over_Limit_Max: this.items[x].device_is_over_limit_max,
          Over_Limit_Min: this.items[x].device_is_over_limit_min,
          Power_Disconect: this.items[x].device_is_power_disconnect,
          Power_Low: this.items[x].device_is_power_low,
          Power_Shutdown: this.items[x].device_is_power_shutdown,
          Probe_Fault: this.items[x].device_is_probe_fault,
          Province: this.items[x].province_name,
          Regency: this.items[x].regency_name,
        }
      }
      const data_json = XLSX.utils.json_to_sheet(jsons)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data_json, 'data')
      XLSX.writeFile(wb, 'Device_data.xlsx')
    },
  },
  directives: {
    Ripple,
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.table.b-table>thead>tr>th {
  background-color: white;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
</style>
